import axios from 'axios';
import config from '../hoa-config';
import datastore from '../store/hoa-datastore';


axios.defaults.baseURL = config.baseUrl;


export default class propertyTaskService {
    static async createPropertyTask(data:any) {
		return await axios.post(`/createPropertyTask`, data);
	}

	static async getPropertyTasks(pageNo:number, numberOfItems:number, options:any, signal:any) {
		try {
			return await axios.get(`/getPropertyTask?&env=${datastore.env}&pageNo=${pageNo}&numberOfItems=${numberOfItems}`, {
				signal: signal,
				params: {
					options: {...options, userRole:datastore.userRole}
				}
			});
		} catch (error) {
			
		}
	}

	static async deletePropertyTask(data:any) {
		return await axios.post(`/deletePropertyTask`, data);
	}

	static async deletePropertyTaskById(id:string) {
		return await axios.post(`/deletePropertyTaskById`, {
			id:id
		});
	}

	static async updateMailVerifiedStatus(data:any) {
		return await axios.post(`/updateMailVerifiedStatus`, data);
	}

	static async getPropertyTasksWhichAreFinished(pageNo:number, numberOfItems:number, options:any) {
		try {
			return await axios.get(`/getPropertyTaskWhichAreFinished?&env=${datastore.env}&pageNo=${pageNo}&numberOfItems=${numberOfItems}`, {
				params: {
					options: {...options, userRole:datastore.userRole}
				}
			});
		} catch (error) {
			
		}
	}
}